import { RadioButtonChecked, RadioButtonUnchecked } from "@mui/icons-material";
import { Button } from "@mui/material"

const selectedButtonClasses = "bg-white text-primary border-primary";
const defaultButtonClasses = "text-gray-600 border-slate-300 font-normal";
export const ReportButton = ({ label = "Flavor Report", type = "Made", isSelected = false, onClick = () => { } }) => {

    return (
        <Button
            className={`mr-3 py-2 px-4 capitalize ${isSelected ? selectedButtonClasses : defaultButtonClasses}`}
            variant="outlined"
            size="small"
            onClick={() => onClick(type)}
            startIcon={isSelected ? <RadioButtonChecked /> : <RadioButtonUnchecked />}
        >
            {label}
        </Button>
    )
}